function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m61.342 19.957h-56.688c-2.4401 0-4.4182 1.9806-4.4182 4.4238v35.195c0 2.4431 1.9781 4.4237 4.4182 4.4237h56.688c2.4401 0 4.4182-1.9806 4.4182-4.4237v-35.195c0-2.4432-1.9781-4.4238-4.4182-4.4238z",
  fill: "#4DD0FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m58.508 64v-19.549c0-0.5139-0.3512-0.9295-0.7835-0.9295h-16.73c-0.4322 0-0.7834 0.4156-0.7834 0.9295v19.549h18.297z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m34.267 26.434h0.0368v-6.4745h-10.374v6.4745c0 2.7196 2.3233 4.9229 5.1869 4.9229 2.6402 0 4.8162-1.8713 5.1428-4.2934v-0.0147c0.027-0.2017 0.0417-0.4082 0.0417-0.6173h-0.0368l0.0025 0.0025z",
  fill: "#1F75DB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m43.3 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m45.462 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m47.623 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m49.786 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m51.948 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m54.109 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m56.27 52.293h-0.7515v8.2081h0.7515v-8.2081z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m40.223 15.814 0.0221 8.9212v6.8237h15.76c8.7039 0 15.76-7.0647 15.76-15.779 0-8.7146-7.0559-15.779-15.76-15.779-8.7038 0-15.76 7.0647-15.76 15.779l-0.0221 0.0369v-0.0025z",
  fill: "#1F75DB"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m55.996 23.82c-4.4305 0-8.0333-3.6073-8.0333-8.0433s3.6028-8.0434 8.0333-8.0434c4.4306 0 8.0334 3.6074 8.0334 8.0434s-3.6028 8.0433-8.0334 8.0433zm0-15.106c-3.8902 0-7.0534 3.1672-7.0534 7.0622s3.1632 7.0622 7.0534 7.0622c3.8903 0 7.0535-3.1672 7.0535-7.0622s-3.1632-7.0622-7.0535-7.0622z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m55.004 18.548c-0.1253 0-0.2505-0.0467-0.3463-0.1426l-2.5738-2.5746c-0.1916-0.1918-0.1916-0.5016 0-0.6934 0.1915-0.1918 0.501-0.1918 0.6925 0l2.2251 2.2278 4.2071-4.2122c0.1915-0.1918 0.501-0.1918 0.6925 0 0.1916 0.1918 0.1916 0.5016 0 0.6934l-4.5533 4.559c-0.0958 0.0959-0.221 0.1426-0.3463 0.1426h0.0025z",
  fill: "#fff"
});

function SvgDeliveredPackageReminderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 74,
    viewBox: "0 0 72 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = React.forwardRef(SvgDeliveredPackageReminderIcon);
export default __webpack_public_path__ + "static/media/delivered-package-reminder-icon.134d4985.svg";
export { ForwardRef as ReactComponent };